export default __webpack_public_path__ + "static/media/bidifylogo_egem.3a94a7b0.png";